<template>
  <v-container fluid pa-0>
    <v-layout text-center>
      <v-flex xs12>
        <div class="map">
          <longdo-map v-if="longdoMapbool" :mapOptions="mapOptions" @onload="initMap" />
        </div>
      </v-flex>
    </v-layout>
    <v-layout class="menu-container pt-4 pa-3">
      <v-flex xs12 class="d-flex flex-column">
        <SearchFormCard
          v-if="longdoMapbool && initmapcount !== 0"
          :map="map"
          :isLogin="userAdmin"
          :optionItems="optionItems"
          ref="search-form-card"
          @pin-change="drawPinMarker"
          @goto-list="gotoAccidentList"
          @click.native="OpenMenu('search-form-card')"
        />
        <LayerFormCard
          :map="map"
          @layer-change="layerChanged"
          @clearpin="HideAllPins"
          @redrawpin="ShowAllPins"
          ref="layer-form-card"
          @click.native="OpenMenu('layer-form-card')"
        />
        <DisplayFormCard
          :map="map"
          @changePintype="changePintype"
          ref="display-form-card"
          @click.native="OpenMenu('display-form-card')"
        />
        <AnalyzeFormCard
          v-if="longdoMapbool && initmapcount !== 0"
          :map="map"
          :isLogin="userAdmin"
          :optionItems="optionItems"
          @pin-change="drawPinMarker"
          @goto-list="AnalyzeToReport"
          ref="analyze-form-card"
          @click.native="OpenMenu('analyze-form-card')"
        />

        <v-card
          class="my-2 pa-2 d-flex flex-column align-center overflow-y-auto"
          :class="{ 'hidden-none': $vuetify.breakpoint.xsOnly || windowHeight < 600 }"
          width="250px"
          max-height="500px"
          style="pointer-events: auto;z-index:1;"
        >
          <v-row
            v-for="data in infoData"
            xs12
            :key="'info-' + data.id"
            class="d-flex align-content-center align-center flex-wrap flex-row"
            pa-2
            style="width:100%"
          >
            <v-col cols="3">
              <div :style="{ 'background-color': data.color }" class="info-pin-color mobile"></div>
            </v-col>
            <v-col col="9">
              {{ data.name }}
            </v-col>
          </v-row>
        </v-card>

        <div class="ui-bottom-container mt-auto d-flex">
          <!-- <v-card
            :width="infoData.length * 120"
            height="50"
            class="d-flex mt-auto mr-auto"
            :class="{ 'hidden-none': $vuetify.breakpoint.xsOnly }"
          >
            <v-layout my-auto>
              <template v-for="data in infoData">
                <v-flex
                  :key="'info-' + data.id"
                  class="d-flex align-content-center align-center flex-wrap flex-column"
                >
                  <div class="d-block width-fit-content">
                    <div :style="{ 'background-color': data.color }" class="info-pin-color"></div>
                    <p class="caption mb-0 mt-1">{{ data.name }}</p>
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </v-card> -->
          <v-layout class="mr-2 flex-column align-end mt-auto">
            <v-card
              v-if="isIrapShow"
              width="300"
              height="70"
              class="d-flex mt-2 mr-0 row"
              :class="{ 'hidden-none': $vuetify.breakpoint.xsOnly }"
            >
              <div class="caption ml-2 mt-1">การประเมินสภาพถนน</div>
              <v-layout my-auto>
                <template v-for="data in iRapData">
                  <v-flex
                    :key="'info-' + data.id"
                    class="d-flex align-content-center align-center flex-wrap flex-column"
                  >
                    <div class="d-block width-fit-content">
                      <div
                        :style="{ 'background-color': data.color }"
                        class="info-line-color"
                      ></div>
                      <p class="caption mb-0 mt-1">{{ data.name }}</p>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </v-card>
            <v-card
              v-if="isIticShow"
              width="300"
              height="70"
              class="d-flex mt-2 mr-0 row"
              :class="{ 'hidden-none': $vuetify.breakpoint.xsOnly }"
            >
              <div class="caption ml-2 mt-1">สภาพการจราจร</div>
              <v-layout my-auto>
                <template v-for="data in trafficData">
                  <v-flex
                    :key="'info-' + data.id"
                    class="d-flex align-content-center align-center flex-wrap flex-column"
                  >
                    <div class="d-block width-fit-content">
                      <div
                        :style="{ 'background-color': data.color }"
                        class="info-line-color"
                      ></div>
                      <p class="caption mb-0 mt-1">{{ data.name }}</p>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </v-card>
            <v-card
              v-if="isAADTShow"
              width="450"
              height="70"
              class="d-flex mt-2 mr-0 row"
              :class="{ 'hidden-none': $vuetify.breakpoint.xsOnly }"
            >
              <div class="caption ml-2 mt-1">ปริมาณการจราจร (คันต่อวัน)</div>
              <v-layout my-auto>
                <template v-for="data in aadtData">
                  <v-flex
                    :key="'info-' + data.id"
                    class="d-flex align-content-center align-center flex-wrap flex-column"
                  >
                    <div class="d-block width-fit-content">
                      <div
                        :style="{ 'background-color': data.color }"
                        class="info-line-color"
                      ></div>
                      <p class="caption mb-0 mt-1">{{ data.name }}</p>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
            </v-card>
          </v-layout>

          <v-dialog v-model="infoDialog" max-width="400">
            <template v-slot:activator="{ on }">
              <v-btn
                tile
                fab
                height="50"
                width="50"
                color="white"
                ripple
                elevation="3"
                class="d-flex mt-auto mr-2 btn-radius clickable"
                :class="{ 'hidden-none': $vuetify.breakpoint.smAndUp && windowHeight >= 600 }"
                v-on="on"
              >
                <v-icon color="primary">info</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-layout row wrap ma-0>
                <v-flex xs10>
                  <v-card-text class="subtitle-1 black--text">
                    <p class="title mb-0">คำอธิบาย</p>
                  </v-card-text>
                </v-flex>
                <v-flex xs2 class="d-flex justify-end align-center">
                  <v-btn icon color="primary" class="ma-2" @click="infoDialog = false">
                    <v-icon>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row wrap ma-0 pa-5>
                <template v-for="data in infoData">
                  <v-row
                    xs12
                    :key="'info-' + data.id"
                    class="d-flex align-content-center align-center flex-wrap flex-row"
                    pa-2
                    style="width:100%"
                  >
                    <v-col cols="3">
                      <div
                        :style="{ 'background-color': data.color }"
                        class="info-pin-color mobile"
                      ></div>
                    </v-col>
                    <v-col col="9">
                      {{ data.name }}
                    </v-col>
                  </v-row>
                </template>
              </v-layout>
            </v-card>
          </v-dialog>

          <!-- start hide element -->
          <!-- <div v-show="isShowPopup"> -->
          <div v-show="false">
            <v-card
              min-width="295"
              ref="pointPopup"
              class="clickable"
              :class="{ xs: $vuetify.breakpoint.xsOnly, smAndUp: $vuetify.breakpoint.smAndUp }"
            >
              <!-- class="clickable popup-data" -->
              <v-layout>
                <v-flex xs10 class="d-flex">
                  <p
                    class="subtitle-1 black--text my-auto ml-3"
                    :class="{
                      'd-none': activeMapBtn !== 'single' && !isClusterMode
                    }"
                  >
                    {{ popupData.road }}
                  </p>
                  <p
                    class="subtitle-1 black--text my-auto ml-3"
                    :class="{
                      'd-none': activeMapBtn === 'single' || isClusterMode
                    }"
                  >
                    รวมสายทาง
                  </p>
                </v-flex>
                <v-flex xs2 class="d-flex justify-end">
                  <v-btn icon color="primary" @click="closePopupClicked">
                    <v-icon>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-divider></v-divider>

              <v-layout row wrap ma-0>
                <v-flex
                  xs12
                  :class="{
                    'd-none': activeMapBtn === 'single' || isClusterMode
                  }"
                >
                  <div class="ma-2 mb-0">
                    <p class="subtitle-2 font-weight-regular ma-0 text-left">
                      รวมทั้งหมด
                      <span class="primary--text">{{ currentMarkerLength }}</span> จุด
                    </p>
                  </div>
                </v-flex>
                <v-flex xs12 class="d-flex flex-row">
                  <v-flex xs4>
                    <div class="ma-2 mr-1 pa-2 card-border d-flex flex-column">
                      <img
                        :src="require('@/assets/icons/ic_accident_bl.svg')"
                        class="mr-auto"
                        width="25"
                      />
                      <p class="ml-auto mb-0 primary--text headline">{{ popupData.vehicle }}</p>
                      <p class="mb-1 subtitle-2 text-right font-weight-regular">ยานพาหนะ</p>
                    </div>
                  </v-flex>
                  <v-flex xs4>
                    <div class="ma-2 mr-1 pa-2 card-border d-flex flex-column">
                      <img
                        :src="require('@/assets/icons/death.svg')"
                        class="mr-auto pt-1"
                        width="21"
                      />
                      <p class="ml-auto mb-0 primary--text headline">{{ popupData.dead }}</p>
                      <p class="mb-1 subtitle-2 text-right font-weight-regular">ผู้เสียชีวิต</p>
                    </div>
                  </v-flex>
                  <v-flex xs4>
                    <div class="ma-2 mr-2 pa-2 card-border d-flex flex-column">
                      <img
                        :src="require('@/assets/icons/ic_injury_bl.svg')"
                        class="mr-auto"
                        width="25"
                      />
                      <p class="ml-auto mb-0 primary--text headline">{{ popupData.injury }}</p>
                      <p class="mb-1 subtitle-2 text-right font-weight-regular">ผู้บาดเจ็บ</p>
                    </div>
                  </v-flex>
                </v-flex>
                <v-expand-transition>
                  <v-flex xs12 v-show="showMorePopup">
                    <v-flex xs12 v-show="popupData.cause_main != null">
                      <div
                        class="ma-2 mr-2 pa-2 card-border d-flex flex-row"
                        title="มูลเหตุสันนิษฐานหลัก"
                      >
                        <img :src="require('@/assets/icons/other_reason.svg')" width="25" />
                        <p class="ml-2 my-auto subtitle-2 font-weight-regular text-left">
                          {{ popupData.cause_main }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-show="popupData.accident_pattern != null">
                      <div class="ma-2 mr-2 pa-2 card-border d-flex flex-row" title="ลักษณะการชน">
                        <img :src="require('@/assets/icons/other_appearance.svg')" width="25" />
                        <p class="ml-2 my-auto subtitle-2 font-weight-regular text-left">
                          {{ popupData.accident_pattern }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-show="popupData.surround_character != null">
                      <div class="ma-2 mr-2 pa-2 card-border d-flex flex-row" title="ลักษณะทาง">
                        <img :src="require('@/assets/icons/other_location.svg')" width="25" />
                        <p class="ml-2 my-auto subtitle-2 font-weight-regular text-left">
                          {{ popupData.surround_character }}
                        </p>
                      </div>
                    </v-flex>
                  </v-flex>
                </v-expand-transition>

                <v-flex
                  xs12
                  px-2
                  v-show="activeMapBtn !== 'single' && userAdmin"
                  class="row mb-2 mx-2"
                  @click="gotoAccidentList(currentMarker.map(i => i.id))"
                >
                  <v-icon size="15" color="primary">description</v-icon>
                  <p class="caption primary--text mb-0 ml-1 cursor-pointer">
                    เปิดหน้ารายการอุบัติเหตุ
                  </p>
                </v-flex>
                <v-flex
                  xs12
                  px-2
                  class="flex-row mb-2"
                  v-show="activeMapBtn === 'single'"
                  :class="{
                    'd-flex': activeMapBtn === 'single',
                    'd-none': activeMapBtn !== 'single'
                  }"
                >
                  <p class="caption grey--text text--darken-1 mb-0 ml-1">
                    {{ popupData.date }}, {{ popupData.time }}
                  </p>
                  <div class="ml-auto my-auto">
                    <v-icon
                      size="15"
                      color="primary"
                      v-show="userLogin"
                      @click="goToPageWithNewTab('report_detail', { data: popupData.id })"
                      >description</v-icon
                    >
                    <v-icon
                      size="15"
                      color="primary"
                      v-show="activeMapBtn === 'single'"
                      @click="toggleMorePopup"
                      >{{ showMorePopup ? 'unfold_less' : 'unfold_more' }}</v-icon
                    >
                  </div>
                </v-flex>
              </v-layout>
            </v-card>

            <v-dialog v-model="clusterDialog" width="400" persistent>
              <v-card class="pt-5">
                <v-card-text class="subtitle-1 black--text">
                  ข้อมูลหมุดที่เลือกจะหายไปเมื่อเปิดโหมด Cluster, ต้องการดำเนินการต่อใช่หรือไม่ ?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="cancelClusterDialog">ยกเลิก</v-btn>
                  <v-btn color="primary" @click="confirmClusterDialog">ดำเนินการต่อ</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <!-- end hide element -->
          <div class="mt-auto" v-if="$vuetify.breakpoint.width > 450">
            <v-card
              width="166"
              height="50"
              class="mb-2 ml-auto btn-radius d-flex align-center justify-center clickable"
              white
            >
              <v-switch
                v-model="clusterSwitch"
                class="ma-0 pa-0"
                label=" เปิด Cluster"
                color="primary"
                hide-details
              ></v-switch>
            </v-card>

            <v-btn
              tile
              fab
              height="50"
              width="50"
              color="white"
              ref="activeMapBtnClose"
              ripple
              elevation="3"
              class="mt-auto ml-2 btn-radius"
              v-show="false"
              @click="activeMapBtn = 'off'"
            >
              <img
                :src="require('@/assets/icons/ic_many_point_wh.svg')"
                class="my-auto ml-auto mr-2 mx-sm-auto"
              />
            </v-btn>

            <div :class="{ clickable: isClusterMode === false }">
              <v-btn
                tile
                fab
                height="50"
                width="50"
                v-show="activeMapBtn !== 'polygon' || !currentMarker.length"
                :color="activeMapBtn === 'polygon' ? 'primary' : 'white'"
                ripple
                elevation="3"
                class="mt-auto ml-auto btn-radius"
                :class="{ 'disabled-icon-style': isClusterMode === true }"
                @click="polygonBtnClicked()"
              >
                <!-- <v-icon color="primary">mdi-vuetify</v-icon> -->
                <img
                  :src="
                    activeMapBtn === 'polygon'
                      ? require('@/assets/icons/ic_area_wh.svg')
                      : require('@/assets/icons/ic_area.svg')
                  "
                  class="my-auto ml-auto mr-2 mx-sm-auto"
                />
              </v-btn>

              <v-btn
                tile
                fab
                height="50"
                width="50"
                v-show="activeMapBtn === 'polygon' && currentMarker.length"
                :color="activeMapBtn === 'polygon' ? 'primary' : 'white'"
                ripple
                elevation="3"
                class="mt-auto ml-auto btn-radius"
                @click="deleteBtnClicked"
              >
                <v-icon color="white">delete</v-icon>
              </v-btn>

              <v-btn
                tile
                fab
                height="50"
                width="50"
                ref="activeMapBtnSingle"
                :color="activeMapBtn === 'single' ? 'primary' : 'white'"
                ripple
                elevation="3"
                class="mt-auto ml-2 btn-radius"
                :class="{ 'disabled-icon-style': isClusterMode === true }"
                @click="activeMapBtn = 'single'"
              >
                <img
                  :src="
                    activeMapBtn === 'single'
                      ? require('@/assets/icons/ic_point_wh.svg')
                      : require('@/assets/icons/ic_point.svg')
                  "
                  class="my-auto ml-auto mr-2 mx-sm-auto"
                />
              </v-btn>

              <v-btn
                tile
                fab
                height="50"
                width="50"
                :color="activeMapBtn === 'multiple' ? 'primary' : 'white'"
                ripple
                elevation="3"
                class="mt-auto ml-2 btn-radius"
                :class="{ 'disabled-icon-style': isClusterMode === true }"
                @click="activeMapBtn = 'multiple'"
              >
                <img
                  :src="
                    activeMapBtn === 'multiple'
                      ? require('@/assets/icons/ic_many_point_wh.svg')
                      : require('@/assets/icons/ic_many_point.svg')
                  "
                  class="my-auto ml-auto mr-2 mx-sm-auto"
                />
              </v-btn>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import cloneDeep from 'clone-deep';
import SearchFormCard from './map-menu/SearchFormCard.vue';
import LayerFormCard from './map-menu/LayerFormCard.vue';
import DisplayFormCard from './map-menu/DisplayFormCard.vue';
import AnalyzeFormCard from './map-menu/AnalyzeFormCard.vue';

export default {
  name: 'Map',
  components: {
    SearchFormCard,
    LayerFormCard,
    DisplayFormCard,
    AnalyzeFormCard
  },
  props: {
    userAdmin: {
      type: Boolean
    },
    userLogin: {
      type: Boolean
    }
  },
  data: () => ({
    map: {},
    longdoMapbool: true,
    isIrapShow: false,
    isIticShow: false,
    isAADTShow: false,
    markerCluster: undefined,
    clusterSwitch: true,
    isClusterMode: true,
    clusterDialog: false,
    initmapcount: 0,
    showMorePopup: false,

    //
    infoData: [
      {
        id: 1,
        name: 'มีผู้เสียชีวิต',
        color: '#E54434'
      },
      {
        id: 2,
        name: 'มีผู้บาดเจ็บ',
        color: '#FF8B09'
      },
      {
        id: 3,
        name: 'ไม่มีผู้เสียชีวิตและบาดเจ็บ',
        color: '#FFD900'
      }
    ],
    iRapData: [
      {
        id: 1,
        name: '1 ดาว',
        color: '#000000'
      },
      {
        id: 2,
        name: '2 ดาว',
        color: '#FF0000'
      },
      {
        id: 3,
        name: '3 ดาว',
        color: '#FF8800'
      },
      {
        id: 4,
        name: '4 ดาว',
        color: '#FFFF00'
      },
      {
        id: 5,
        name: '5 ดาว',
        color: '#00FF00'
      }
    ],
    trafficData: [
      {
        id: 1,
        name: 'คล่องตัว',
        color: '#5EB42A'
      },
      {
        id: 2,
        name: 'หนาแน่น',
        color: '#F9C70C'
      },
      {
        id: 3,
        name: 'ติดขัด',
        color: '#EC343C'
      },
      {
        id: 4,
        name: 'ติดขัดมาก',
        color: '#B01F26'
      },
      {
        id: 5,
        name: 'ปิดถนน',
        color: '#000000'
      }
    ],
    aadtData: [
      {
        id: 1,
        name: '> 0',
        color: '#FCB30A'
      },
      {
        id: 2,
        name: '> 1,000',
        color: '#D064F3'
      },
      {
        id: 3,
        name: '> 5,000',
        color: '#27BBF1'
      },
      {
        id: 4,
        name: '> 10,000',
        color: '#0E6600'
      },
      {
        id: 5,
        name: '> 20,000',
        color: '#0000FF'
      },
      {
        id: 6,
        name: '> 40,000',
        color: '#F1024E'
      },
      {
        id: 7,
        name: '> 80,000',
        color: '#FF0000'
      }
    ],
    markerType: {
      dead: 'dead',
      injury: 'injury',
      none: 'none'
    },
    activeMapBtn: 'single',
    markerList: [],
    currentMarker: [],
    accidentList: [],
    //
    // isShowPopup: false,
    currentPopup: {},
    popupData: {
      id: '',
      date: '',
      time: '',
      road: '',
      vehicle: 0,
      dead: 0,
      injury: 0
    },
    //
    currentToolbarStatus: '',
    isMapBound: false,
    infoDialog: false,
    updatingMarker: false,
    optionItems: {},
    pinType: 'isSeverityActive',
    pinData: [],
    windowHeight: ''
  }),
  created() {},
  mounted() {
    // console.log(this.$refs.pointPopup.$el.outerHTML);
    this.getHeight();
    window.addEventListener('resize', this.getHeight, { passive: true });
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.getHeight, { passive: true });
    }
  },
  methods: {
    OpenMenu(menu) {
      const menu_refs = [
        'search-form-card',
        'layer-form-card',
        'display-form-card',
        'analyze-form-card'
      ];
      let len = menu_refs.length;
      while (len--) {
        const element = menu_refs[len];
        if (element !== menu && this.$refs[element]) {
          this.$refs[element].deActivatebtn();
        }
      }
    },
    getHeight() {
      this.windowHeight = window.innerHeight;
    },
    initMap(map) {
      this.getOptionLists();
      if (this.initmapcount === 0) {
        this.longdoMapbool = false;
        this.initmapcount += 1;
        let l = longdo.MapTheme.ui.layerSelectorDropdown.length;
        longdo.MapTheme.ui.layerSelectorOption.th.button.pop(2);
        longdo.MapTheme.ui.layerSelectorOption.en.button.pop(2);
        longdo.MapTheme.ui.measureDistanceTip =
          'คลิกบนแผนที่เพื่อสร้างพื้นที่\nหรือคลิกจุดเริ่มต้นเพื่อเสร็จสิ้น';
        longdo.MapTheme.ui.measureAreaTip = 'คลิกเพื่อเสร็จสิ้น';
        longdo.MapTheme.ui.measureBeginTip = 'คลิกเพื่อเริ่มสร้างพื้นที่';
        if (longdo.MapTheme.ui.layerSelectorDropdown[0].label != 'MOT Basemap') {
          const dropdown = longdo.MapTheme.ui.layerSelectorDropdown;
          const layer1 = {
            label: 'AEC Basemap',
            value: new longdo.Layer('0', {
              type: longdo.LayerType.WMS,
              url: 'https://maps.mot.go.th/arcgis/services/MOTOC/AEC_Basemap/MapServer/WMSServer'
            })
          };
          const layer2 = {
            label: 'MOT Basemap',
            value: new longdo.Layer('', {
              type: longdo.LayerType.Custom,
              url(projection, tile, zoom, hd) {
                return `https://maps.mot.go.th/arcgis/rest/services/Bee/BasemapMOT/MapServer/tile/${zoom}/${tile.v}/${tile.u}`;
              }
            })
          };
          dropdown.unshift(layer1);
          dropdown.unshift(layer2);
        }
        while (l--) {
          if (longdo.MapTheme.ui.layerSelectorDropdown[l].label.indexOf('Google') > -1) {
            longdo.MapTheme.ui.layerSelectorDropdown.splice(l, 1);
          }
        }
        this.$nextTick(() => {
          this.longdoMapbool = true;
        });
      }
      this.map = map;
      window.mapdebug = this.map;
      this.map.zoom(6);
      this.map.location({ lat: 13.070323, lon: 100.443766 });

      this.getMapLayer();

      // init
      this.initMapUi();
      // this.randomMarker();
      this.bindOverlayClick();
      this.bindOverlayDrop();
      this.bindToolbarChange();
      this.bindLocation();
    },
    initMapUi() {
      // this.map.Ui.Toolbar.visible(false);
      this.map.Ui.LayerSelector.visible(true);
      this.map.Ui.Fullscreen.visible(false);
      this.map.Ui.Scale.visible(this.isXs);
      // this.map.Ui.TopRight.insertBefore(
      //   document.getElementsByClassName('ldmap_navigation')[0],
      //   this.map.Ui.TopRight.firstChild
      // );
      const container = document.createElement('div');
      // container.setAttribute('class', 'd-felx justify-end');
      container.appendChild(document.getElementsByClassName('ldmap_navigation')[0]);

      this.map.Ui.TopRight.appendChild(container);
      // })
    },
    goToPage(name, data) {
      this.$router.push({
        name
      });
    },
    goToPageWithNewTab(name, data) {
      const routeData = this.$router.resolve({ name, query: data });
      window.open(routeData.href, '_blank');
    },
    gotoAccidentList(list) {
      if (list == null) {
        list = this.accidentList;
      }
      localStorage.setItem('accidentList', list.join(','));
      const routeData = this.$router.resolve({ name: 'report' });
      window.open(routeData.href, '_blank');
    },
    AnalyzeToReport(item) {
      if (item) localStorage.setItem('accidentList', item.join(','));
      const routeData = this.$router.resolve({ name: 'report' });
      window.open(routeData.href, '_blank');
    },
    getMarker(type) {
      switch (type) {
        case this.markerType.dead:
          /* eslint-disable global-require */
          return require('@/assets/marker/ic_pin_rd.svg');
        case this.markerType.injury:
          /* eslint-disable global-require */
          return require('@/assets/marker/ic_pin_or.svg');
        case this.markerType.none:
          /* eslint-disable global-require */
          return require('@/assets/marker/ic_pin_yw.svg');
        default:
          /* eslint-disable global-require */
          return require('@/assets/marker/ic_pin_yw.svg');
      }
    },
    getSelectedMarker(type) {
      return require('@/assets/marker/ic_pin_selected.svg');
    },
    getMarkerType(damage) {
      if (damage === 3) {
        return this.markerType.dead;
      }
      if (damage === 2) {
        return this.markerType.injury;
      }
      return this.markerType.none;
    },
    toggleMorePopup() {
      this.showMorePopup = !this.showMorePopup;
    },
    getMapLayer() {
      const self = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://api.nostramap.com/Service/V2/Map/GetPermission?key=';
      const key = `${process.env.VUE_APP_NOSTRA_MAP_KEY}`;

      this.axios({
        url: baseUrl + key,
        adapter: jsonpAdapter
      })
        .then(response => {
          if (response.status === 200 && response.data.results !== null) {
            self.setBaseMap(response.data.results);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    setBaseMap(layer) {
      const base = layer.filter(x => x.serviceID === '1');
      if (base.length === 1) {
        const nostraSteet = new window.longdo.Layer(false, {
          type: window.longdo.LayerType.ArcGIS_REST,
          url: base[0].serviceURL_L,
          key: base[0].serviceToken_L
        });

        this.map.Layers.setBase(nostraSteet);
      }
    },
    makeMarker(id, type, vehicle_id, data, location, isSelected = false) {
      let title = `รหัส ${id}`;
      if (this.pinType === 'isSeverityActive') {
        switch (type) {
          case this.markerType.dead:
            title += ': มีผู้เสียชีวิต';
            break;
          case this.markerType.injury:
            title += ': มีผู้บาดเจ็บ';
            break;
          case this.markerType.none:
            title += ': ไม่มีผู้เสียชีวิตและบาดเจ็บ';
            break;
          default:
            break;
        }
      } else if (this.pinType === 'isVehicleActive' && vehicle_id) {
        title += `: ${this.optionItems.vehicle.filter(e => e.id == vehicle_id).shift().name}`;
      } else if (this.pinType === 'isCrashActive') {
        title += `: ${
          this.optionItems.accident_pattern.filter(e => e.id == data.accident_pattern_code).shift()
            .name
        }`;
      }
      const marker = new window.longdo.Marker(location, {
        title,
        icon: {
          // html: `<img width="${isSelected ? 32 : 24}" height="${isSelected ? 32 : 24}" src="${
          //   isSelected ? this.getSelectedMarker(type) : this.getMarker(type)
          // }"/>`,
          html: `<svg width="${isSelected ? '32px' : '24px'}" height="${
            isSelected ? '32px' : '24px'
          }" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="pin${id}" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <path d="M8,14 C11.3333333,10.6184933 13,7.98754093 13,6.10714286 C13,3.28654574 10.7614237,1 8,1 C5.23857625,1 3,3.28654574 3,6.10714286 C3,7.98754093 4.66666667,10.6184933 8,14 Z" id="Oval" stroke="${this.getMarkerstroke(
                            type,
                            isSelected
                          )}" fill="${this.getMarkerFill(
            type,
            data,
            vehicle_id,
            isSelected
          )}"></path>
                          <circle id="Oval" stroke="#525252" fill="#FFFFFF" cx="8" cy="6" r="2"></circle>
                      </g>
                  </svg>`,
          offset: { x: isSelected ? 16 : 12, y: isSelected ? 32 : 24 }
        },
        clickable: true,
        weight: 0
      });
      marker.data = data;
      marker.id = id;
      marker.markerType = type;
      marker.vehicle_id = vehicle_id;
      marker.color = this.getMarkerFill(type, data, vehicle_id, isSelected);
      return marker;
    },
    getMarkerstroke(type, isSelected) {
      return '#000000';
    },
    getMarkerFill(type, data, vehicle_id, isSelected) {
      if (isSelected) return '#000000';

      if (this.pinType === 'isSeverityActive') {
        switch (type) {
          case this.markerType.dead:
            return '#E54434';
          case this.markerType.injury:
            return '#FF8B09';
          case this.markerType.none:
            return '#FFD900';
          default:
            return '#FFD900';
        }
      } else if (this.pinType === 'isVehicleActive' && vehicle_id) {
        return this.getPinColor(vehicle_id);
      } else {
        return this.getPinColor(data.accident_pattern_code);
      }
    },
    getPinColor(type) {
      const color = [
        '#22650d',
        '#c02529',
        '#855ae7',
        '#b357c2',
        '#43fa99',
        '#176ce0',
        '#98cadf',
        '#4df0f0',
        '#e7d303',
        '#ffe3af',
        '#594314',
        '#f1e5dd',
        '#71a1f1',
        '#b5b342',
        '#3b3245',
        '#e99701',
        '#935d2c'
      ];
      return color[parseInt(type)];
    },
    // randomData() {
    //   const data = {};
    //   data.road = `สายทาง ${Math.floor(Math.random() * 1000)}`;
    //   data.vehicle = Math.floor(Math.random() * 10);
    //   data.dead = Math.floor(Math.random() * 10);
    //   data.injury = Math.floor(Math.random() * 10);

    //   return data;
    // },
    // randomLocation(centerLat, centerLng, distance = 250000) {
    //   // Convert to radians
    //   const lat = (centerLat * Math.PI) / 180;
    //   const lng = (centerLng * Math.PI) / 180;

    //   let radius;

    //   // Distance should be set in meters, negative for exact distance
    //   if (distance < 0) {
    //     // Exact distance
    //     radius = Math.abs(distance);
    //   } else {
    //     // Get uniformly-random distribution within peovided distance
    //     // http://stackoverflow.com/questions/5837572/generate-a-random-point-within-a-circle-uniformly
    //     radius = Math.random() + Math.random();
    //     radius = radius > 1 ? 2 - radius : radius;
    //     radius *= distance || 10000; // multiply by distance meters
    //   }

    //   // Convert radius from meters to degrees to radians
    //   // 111319.9 meters = one degree along the equator
    //   radius /= 111319.9;
    //   // Correction for the actual distance from equator is NOT needed here
    //   // radius *= Math.cos(lat);
    //   // Convert to radians
    //   radius *= Math.PI / 180;

    //   // Random angle
    //   const angle = Math.random() * Math.PI * 2;

    //   // Get a point {nLat,nLng} in a distance={radius} out on the {angle} radial from point {lat,lng}
    //   // From Aviation Formulary V1.46 By Ed Williams:
    //   // → http://williams.best.vwh.net/avform.htm#LL
    //   // → ftp://ftp.bartol.udel.edu/anita/amir/My_thesis/Figures4Thesis/CRC_plots/Aviation%20Formulary%20V1.46.pdf
    //   // → https://github.com/arildj78/AvCalc/blob/master/avform.txt
    //   // [section "Lat/lon given radial and distance"]
    //   let nLng;
    //   let nLat = Math.asin(
    //     Math.sin(lat) * Math.cos(radius) + Math.cos(lat) * Math.sin(radius) * Math.cos(angle)
    //   );
    //   if (Math.cos(nLat) === 0) {
    //     nLng = lng;
    //   } else {
    //     nLng =
    //       ((lng - Math.asin((Math.sin(angle) * Math.sin(radius)) / Math.cos(nLat)) + Math.PI) %
    //         (Math.PI * 2)) -
    //       Math.PI;
    //   }

    //   // Convert to degrees
    //   nLat *= 180 / Math.PI;
    //   nLng *= 180 / Math.PI;

    //   return { lat: nLat, lon: nLng };
    // },
    // randomMarker() {
    //   /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
    //   for (let i = 0; i < 40; i++) {
    //     const type = this.getMarkerType(i + 1);
    //     const data = this.randomData();
    //     const location = this.randomLocation(15.635146, 101.102945);
    //     const marker = this.makeMarker(i + 1, type, data, location);

    //     this.markerList.push(marker);
    //   }
    //   this.initMapMarker();
    // },
    changePintype(type) {
      this.pinType = type;
      this.getPinColorInfo();
      for (let index = 0; index < this.markerList.length; index++) {
        const pin = this.markerList[index];
        this.map.Overlays.remove(pin);
      }
      this.markerList = [];
      this.drawPinMarker(this.pinData);
    },
    getPinColorInfo() {
      if (this.pinType === 'isSeverityActive') {
        this.infoData = [
          {
            id: 1,
            name: 'มีผู้เสียชีวิต',
            color: '#E54434'
          },
          {
            id: 2,
            name: 'มีผู้บาดเจ็บ',
            color: '#FF8B09'
          },
          {
            id: 3,
            name: 'ไม่มีผู้เสียชีวิตและบาดเจ็บ',
            color: '#FFD900'
          }
        ];
      } else if (this.pinType === 'isVehicleActive') {
        this.infoData = [];
        for (let index = 0; index < this.optionItems.vehicle.length; index++) {
          const element = this.optionItems.vehicle[index];
          this.infoData.push({
            id: element.id,
            name: element.name,
            color: this.getPinColor(element.id)
          });
        }
      } else if (this.pinType === 'isCrashActive') {
        this.infoData = [];
        for (let index = 0; index < this.optionItems.accident_pattern.length; index++) {
          const element = this.optionItems.accident_pattern[index];
          this.infoData.push({
            id: element.id,
            name: element.name,
            color: this.getPinColor(element.id)
          });
        }
      }
    },
    HideAllPins() {
      this.markerList.forEach(pin => {
        this.map.Overlays.remove(pin);
      });
    },
    ShowAllPins() {
      const pinDataList = this.markerList;
      pinDataList.forEach(pinData => {
        const { id } = pinData;
        const type = this.getMarkerType(pinData.damage);
        const { vehicle_id } = pinData;
        let route_code = '';
        if (pinData.department == 'DOH') {
          route_code = `ทางหลวง ${pinData.route_code}`;
        } else if (pinData.department == 'DRR') {
          route_code = pinData.route_code;
        } else if (pinData.department == 'EXAT' || pinData.department == 'BMTA') {
          route_code = pinData.route_name;
        } else if (pinData.route_code) {
          route_code = `สายทาง ${pinData.route_code}`;
        } else {
          route_code = '-';
        }
        const data = {
          id: pinData.id,
          road: route_code + (pinData.km ? ` กม. ${pinData.km}` : ''),
          vehicle: pinData.vehicle || 0,
          dead: pinData.dead || 0,
          injury: pinData.injury || 0,
          date: pinData.accident_date,
          time: pinData.accident_time
        };
        const location = {
          lat: pinData.location.latitude,
          lon: pinData.location.longitude
        };
        const marker = this.makeMarker(id, type, vehicle_id, data, location);

        // this.markerList.push(marker);
      });
      this.accidentList = pinDataList.map(member => member.id);

      if (this.isClusterMode === true) {
        this.initMapCluster();
      } else {
        this.initMapMarker();
      }
    },
    clearAllPins() {
      this.markerList.forEach(pin => {
        this.map.Overlays.remove(pin);
      });
      this.markerList = [];
    },
    clearAllCluster() {
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }
    },
    drawPinMarker(pinDataList) {
      this.pinData = pinDataList;
      this.closePopupClicked();
      this.clearAllPins();
      this.clearAllCluster();
      for (let index = 0; index < pinDataList.length; index++) {
        const pinData = pinDataList[index];
        const { id } = pinData;
        const type = this.getMarkerType(pinData.damage);
        const vehicle_id = pinData.vehicle_id[0];
        let route_code = '';
        if (pinData.department == 'DOH') {
          route_code = `ทางหลวง ${pinData.route_code}`;
        } else if (pinData.department == 'DRR') {
          route_code = pinData.route_code;
        } else if (pinData.department == 'EXAT') {
          route_code = pinData.route_name;
        } else if (pinData.route_code) {
          route_code = `สายทาง ${pinData.route_code}`;
        } else {
          route_code = '-';
        }
        const data = {
          id: pinData.id,
          road: route_code + (pinData.km ? ` กม. ${pinData.km}` : ''),
          vehicle: pinData.vehicle || 0,
          dead: pinData.dead || 0,
          injury: pinData.injury || 0,
          date: pinData.accident_date,
          time: pinData.accident_time,
          accident_pattern_code: pinData.accident_pattern_code,
          accident_pattern: pinData.accident_pattern,
          cause_main: pinData.cause_main,
          surround_character: pinData.surround_character
        };
        const location = {
          lat: pinData.location.latitude,
          lon: pinData.location.longitude
        };
        if (location.lat && location.lon) {
          if (this.pinType === 'isSeverityActive') {
            const marker = this.makeMarker(id, type, vehicle_id, data, location);
            this.markerList.push(marker);
          } else if (this.pinType === 'isVehicleActive' && vehicle_id) {
            const marker = this.makeMarker(id, type, vehicle_id, data, location);
            this.markerList.push(marker);
          } else if (this.pinType === 'isCrashActive' && pinData.accident_pattern_code) {
            const marker = this.makeMarker(id, type, vehicle_id, data, location);
            this.markerList.push(marker);
          }
        }
      }
      this.accidentList = pinDataList.map(member => member.id);

      if (this.isClusterMode === true) {
        this.initMapCluster();
      } else {
        this.initMapMarker();
      }
    },
    layerChanged(value) {
      if (value.layer == 'irap') {
        this.isIrapShow = value.show;
      } else if (value.layer == 'itic') {
        this.isIticShow = value.show;
      } else if (value.layer == 'aadt') {
        this.isAADTShow = value.show;
      }
    },
    initMapMarker() {
      this.markerList.forEach(marker => {
        this.map.Overlays.add(marker);
      });
      // let temp= parseInt(Math.random() * this.markerList.length)
      // for (let index = temp; index < temp+10; index++) {
      //   const element = this.markerList[index];
      //   this.map.Overlays.add(element);
      // }
    },
    initMapCluster() {
      const LongdoMapCluster = this.longdoMapCluster;
      this.markerCluster = new LongdoMapCluster(this.map, {
        minClusterSize: 2
      });
      this.markerList.forEach(marker => {
        this.markerCluster.addMarkers(marker);
      });

      this.markerCluster.render();
    },
    manageMarkers(overlay, isMultiple = false) {
      this.map.Overlays.remove(overlay);
      let selectedMarker = {};
      const exist = this.currentMarker.findIndex(x => x.id === overlay.id);
      const { data } = overlay;
      if (exist === -1) {
        // click to select new marker
        // change to selected marker
        selectedMarker = this.getUpdateMarker(overlay, true);
        if (isMultiple) {
          // if mode multiple
          this.currentMarker.push(selectedMarker);
          this.addPopupData(cloneDeep(data));
          if (this.currentMarker.length > 0) {
            this.makePopup();
          }
        } else {
          // if mode single
          this.clearSelectedMarker();
          this.currentMarker = [selectedMarker];
          this.popupData = cloneDeep(data);
          if (this.currentMarker.length > 0) {
            this.makePopup();
          }
        }
      } else {
        // click to deselect marker
        // change to deselected marker
        selectedMarker = this.getUpdateMarker(overlay);
        this.currentMarker.splice(exist, 1);
        this.minusPopupData(cloneDeep(data));
      }

      // add update marker
      this.map.Overlays.add(selectedMarker);

      this.replaceInsideMarkerList(selectedMarker);
    },
    replaceInsideMarkerList(marker) {
      const listIndex = this.markerList.findIndex(x => x.id === marker.id);
      if (listIndex > -1) {
        this.markerList.splice(listIndex, 1, marker);
      }
    },
    clearSelectedMarker() {
      if (this.currentMarkerLength > 0) {
        // change to deselected marker
        this.currentMarker.forEach(marker => {
          const deselectedMarker = this.getUpdateMarker(marker);
          this.map.Overlays.remove(marker);
          this.map.Overlays.add(deselectedMarker);

          this.replaceInsideMarkerList(deselectedMarker);
        });
      }
    },
    bindOverlayClick() {
      this.map.Event.bind('overlayClick', overlay => {
        const { data } = overlay;

        if (
          !(overlay instanceof window.longdo.Marker) ||
          overlay.location() === undefined ||
          this.activeMapBtn === 'polygon' ||
          this.activeMapBtn === 'close' ||
          data === undefined
        ) {
          return;
        }
        if (this.isClusterMode) {
          const scope = this;
          this.$nextTick(() => {
            const markerfromcluster = this.markerCluster.getSelectedMarker();
            if (markerfromcluster) {
              // const markerSelect = scope.markerList.filter(member => {
              //   return markerfromcluster.location().lat === member.location().lat && markerfromcluster.location().lon === member.location().lon
              // })[0]
              // console.log(markerSelect)
              scope.manageMarkers(markerfromcluster);
            }
          });
        } else {
          switch (this.activeMapBtn) {
            case 'single':
              this.manageMarkers(overlay);
              break;
            case 'multiple':
              this.manageMarkers(overlay, true);
              break;
            // case 'polygon':
            //   break;
            default:
          }
        }
        // if (this.currentMarker.length > 0) {
        //   console.log('showpopup')
        //   this.makePopup();
        // }
      });
    },
    bindOverlayDrop() {
      this.map.Event.bind('overlayDrop', overlay => {
        if (overlay instanceof window.longdo.Dot) {
          this.initPolygonMarkerData();
        }
      });
    },
    bindToolbarChange() {
      this.map.Event.bind('toolbarChange', status => {
        // console.log(status);
        if (this.isCreatingPolygon) {
          if (status === null) {
            // console.log(this.map.Ui.Toolbar.measureList());
            this.initPolygonMarkerData();
          }
        }

        this.currentToolbarStatus = status;
      });
    },
    bindLocation() {
      this.map.Event.bind('location', () => {
        if (this.isMapBound) {
          this.isMapBound = false;
        }
      });
    },
    initPolygonMarkerData() {
      const measureList = this.map.Ui.Toolbar.measureList();
      if (measureList.length === 0) {
        return;
      }

      const overlay = measureList[0];
      if (overlay instanceof window.longdo.Polygon) {
        this.getMarkerInsidePolygon(overlay);
        this.makePopup();
      }
    },
    getMarkerInsidePolygon(polygon) {
      const selectedMarkerList = [];
      this.clearSelectedMarker();
      this.clearpopupData();
      this.currentMarker = [];

      this.markerList.forEach(marker => {
        if (polygon.contains(marker)) {
          const selectedMarker = this.getUpdateMarker(marker, true);
          selectedMarkerList.push(selectedMarker);
          this.currentMarker.push(selectedMarker);

          this.addPopupData(cloneDeep(marker.data));

          this.map.Overlays.remove(marker);
          this.map.Overlays.add(selectedMarker);
        }
      });

      selectedMarkerList.forEach(marker => {
        this.replaceInsideMarkerList(marker);
      });
    },
    makePopup() {
      const bound = this.boundToCurrentMarker();
      const location = this.calculateWhenOpenPopupLocation(bound);

      // this.map.location(location);
      // this.isShowPopup = true;
      const popup = new window.longdo.Popup(location, {
        html: '<div id="popupContainer" style="transform: translate(50px, -91px)"></div>',
        weight: window.longdo.OverlayWeight.Top
      });

      this.map.Overlays.add(popup);

      const checkPopupAdd = setInterval(() => {
        if (document.getElementById('popupContainer') !== null) {
          document
            .getElementById('popupContainer')
            .insertBefore(
              this.$refs.pointPopup.$el,
              document.getElementById('popupContainer').firstChild
            );
          clearInterval(checkPopupAdd);
        }
      }, 100);

      this.currentPopup = popup;
    },
    boundToCurrentMarker() {
      let location = [];

      if (this.activeMapBtn !== 'polygon') {
        this.currentMarker.forEach(marker => {
          location.push(marker.location());
        });
      } else {
        const measureList = this.map.Ui.Toolbar.measureList();

        const overlay = measureList[0];
        location = overlay.location();
      }

      // console.log(location);

      const bound = window.longdo.Util.locationBound(location);
      // console.log(bound);
      this.isMapBound = true;
      // this.map.bound(bound);

      return bound;
    },
    calculateWhenOpenPopupLocation(bound) {
      const lat = (bound.maxLat + bound.minLat) / 2;
      const lon = bound.maxLon; // (bound.maxLon + bound.minLon) / 2;
      // console.log('lat', lat);
      // console.log('lon', lon);
      return { lat, lon };
    },
    closePopup() {
      this.clearpopupData();
      this.removeCurrentPopup();

      if (this.currentMarkerLength > 0) {
        this.clearSelectedMarker();
        this.currentMarker = [];
      }
    },
    clearpopupData() {
      this.popupData = {
        id: '',
        date: '',
        time: '',
        road: '',
        vehicle: 0,
        dead: 0,
        injury: 0,
        accident_crash_pattern: '',
        cause_main: '',
        surround_character: ''
      };
      this.showMorePopup = false;
    },
    addPopupData(data) {
      this.popupData.vehicle += parseInt(data.vehicle, 10);
      this.popupData.dead += parseInt(data.dead, 10);
      this.popupData.injury += parseInt(data.injury, 10);
    },
    minusPopupData(data) {
      this.popupData.vehicle -= data.vehicle;
      this.popupData.dead -= data.dead;
      this.popupData.injury -= data.injury;
    },
    removeCurrentPopup() {
      // remove popup
      if (Object.keys(this.currentPopup).length === 0) {
        return;
      }
      this.map.Overlays.remove(this.currentPopup);
      if (document.getElementsByClassName('ldmap_popup_mini')[0]) {
        document.getElementsByClassName('ldmap_popup_mini')[0].style = 'display:none';
      }
      this.currentPopup = {};

      // this.isShowPopup = false;
    },
    closePopupClicked() {
      if (this.activeMapBtn !== 'polygon') {
        this.closePopup();
      } else {
        this.deleteBtnClicked();
      }
    },
    polygonBtnClicked() {
      this.activeMapBtn = 'polygon';
      this.measurementBtnClicked();
    },
    deleteBtnClicked() {
      this.initCreatePolygonState();
      this.closePopup();
    },
    initCreatePolygonState() {
      // console.log('deleteBtnClicked');
      if (!this.isCreatingPolygon) {
        this.clearMeasurementBtnClicked();
        this.measurementBtnClicked();
      } else {
        this.measurementBtnClicked();
        this.measurementBtnClicked();
      }
    },
    measurementBtnClicked() {
      const toolbar = document.getElementsByClassName('ldmap_toolbar');
      let measurementBtn = {};
      toolbar[0].childNodes.forEach(nodes => {
        if (nodes.getAttributeNode('title').value === 'Measurement') {
          measurementBtn = nodes;
        }
      });

      measurementBtn.click();
    },
    clearMeasurementBtnClicked() {
      const toolbar = document.getElementsByClassName('ldmap_toolbar');
      let clearMeasurementBtn = {};
      toolbar[0].childNodes.forEach(nodes => {
        if (nodes.getAttributeNode('title').value === 'Clear measurement') {
          clearMeasurementBtn = nodes;
        }
      });

      clearMeasurementBtn.click();
    },
    getUpdateMarker(marker, isSelected = false) {
      const { id } = marker;
      const type = marker.markerType;
      const { data } = marker;
      const { vehicle_id } = marker;
      const location = marker.location();
      const thisMarker = this.makeMarker(id, type, vehicle_id, data, location, isSelected);
      return thisMarker;
    },
    cancelClusterDialog() {
      this.clusterSwitch = false;
      this.clusterDialog = false;
      this.isClusterMode = false;
    },
    confirmClusterDialog() {
      this.clusterDialog = false;
      this.isClusterMode = true;
      this.startCluster();
    },
    startCluster() {
      this.$refs.activeMapBtnClose.click();
      // this.map.Overlays.clear();
      this.markerList.forEach(pin => {
        this.map.Overlays.remove(pin);
      });
      this.$nextTick(() => {
        this.initMapCluster();
      });
    },
    getOptionLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/search_option`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.optionItems = response.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    filter() {
      return this.searchFilter;
    },
    currentMarkerLength() {
      return this.currentMarker.length;
    },
    isCreatingPolygon() {
      return this.currentToolbarStatus === 'M';
    },
    mapOptions() {
      return {
        ui: this.$vuetify.breakpoint.xsOnly ? 'MOBILE' : 'COMPACT',
        zoomRange: {
          max: 18,
          min: 3
        }
      };
    },
    longdoMapCluster() {
      return require('../assets/resources/cluster/MarkerCluster.js').default;
    },
    isXs() {
      return !this.$vuetify.breakpoint.xsOnly;
    }
  },
  watch: {
    activeMapBtn(newVal, oldVal) {
      if (oldVal === 'polygon') {
        // console.log('activeMapBtn', Object.keys(this.currentPolygon).length);
        if (!this.isCreatingPolygon) {
          this.clearMeasurementBtnClicked();
        } else {
          this.measurementBtnClicked();
        }
      }

      this.closePopup();
    },
    currentMarker(newMarker) {
      if (newMarker.length === 0) {
        this.closePopupClicked();
      }
    },
    clusterSwitch(newValue) {
      if (newValue) {
        this.clusterDialog = true;
      } else {
        // console.log('cluster mode : ', this.isClusterMode);

        if (this.markerCluster === undefined || this.isClusterMode === false) {
          // console.log('return jaaa');
          return;
        }

        this.$refs.activeMapBtnSingle.click();
        // this.markerCluster.clearMarkers();
        this.clearAllCluster();
        this.$nextTick(() => {
          this.initMapMarker();
        });

        this.isClusterMode = false;
      }
    },
    isXs(isXs) {
      this.map.Ui.Scale.visible(isXs);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../assets/resources/cluster/MarkerCluster.Default.css';
.map {
  height: calc(100vh - 64px);
}

.menu-container {
  pointer-events: none;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  .ui-bottom-container {
    .clickable {
      pointer-events: auto;
    }
  }
}

.hidden {
  visibility: hidden;
}

.v-application .hidden-none {
  display: none !important;
}

.info-pin-color {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  margin: auto;

  &.mobile {
    width: 16px;
    height: 16px;
  }
}

.info-line-color {
  width: 50px;
  height: 12px;
  border-radius: 6px;
  margin: auto;

  &.mobile {
    width: 16px;
    height: 16px;
  }
}

.popup-data {
  position: absolute;

  &.xs {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }

  &.smAndUp {
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.width-fit-content {
  width: fit-content;
}

.cursor-pointer {
  cursor: pointer;
}

.disabled-icon-style {
  filter: grayscale(100%) brightness(200%);
}

::v-deep .ldmap_navigation {
  padding-top: 10px;
  position: initial !important;
}

::v-deep .ldmap_topright {
  display: flex;
  flex-direction: column;
  align-items: center;
}

::v-deep .ldmap_bottomright {
  display: none;
}

::v-deep .ldmap_toolbar {
  display: none;
}

::v-deep .ldmap_popupholder {
  pointer-events: none;

  * {
    pointer-events: auto;
  }
}

::v-deep .ldmap_notice {
  display: none;
}

::v-deep .ldmap_scale {
  position: absolute;
  bottom: 10px;
  left: 5px;
}

// ::v-deep .ldmap_popupholder {
//   z-index: 99 !important;
// }
</style>
